export const payload = {
  receiveMutation: 'RECEIVE_INSURANCES',
  receivingMutation: 'RECEIVING_INSURANCES',
  receiveMetadataMutation: 'RECEIVE_INSURANCE_METADATA',
  receiveFailureMutation: 'RECEIVE_INSURANCE_FAILURE',
  savingMutation: 'SAVING_INSURANCE',
  saveFailureMutation: 'SAVING_INSURANCE_FAILURE',
  incrementMutation: 'INCREMENT_INSURANCE_COUNT',
  updatingMutation: 'UPDATING_INSURANCE',
  updateFailureMutation: 'UPDATING_INSURANCE_FAILURE',
  deleteMutation: 'DELETE_INSURANCE',
  deletingMutation: 'DELETING_INSURANCE',
  deleteFailureMutation: 'DELETING_INSURANCE_FAILURE',
  resetMetaMutation: 'RESET_INSURANCE_META',
  clearMutation: 'CLEAR_INSURANCE_STATE',
  moduleName: 'insurance',
  endpoint: 'insurances',
  searchableFields: ['code', 'name', 'description']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Insurances/actionPayload.js